<template>
  <img alt="hantec shield" loading="lazy" height="24px" src="/assets/hantecSmallShield.webp" width="24px" />
</template>
